
import { Config } from '../config';

function globalHelper(config: Config) {
  return {
    getConfig: () => { return config }
  }
}

export function exposeConfig(global) {
  (<any>window).starscrm = globalHelper(global);
}



// WEBPACK FOOTER //
// ./src/services/global-helper.ts